namespace GeniuzPOS.CustomReport {
    export interface ReportCustomerSurveyTranDtRow {
        SurveyCode?: string;
        ChoiceId?: number;
        Choice?: string;
        DocNo?: string;
        PosId?: string;
        ShopId?: string;
        MbId?: string;
        CreateBy?: string;
    }

    export namespace ReportCustomerSurveyTranDtRow {
        export const idProperty = 'SurveyCode';
        export const nameProperty = 'SurveyCode';
        export const localTextPrefix = 'CustomReport.ReportCustomerSurveyTranDt';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            SurveyCode = "SurveyCode",
            ChoiceId = "ChoiceId",
            Choice = "Choice",
            DocNo = "DocNo",
            PosId = "PosId",
            ShopId = "ShopId",
            MbId = "MbId",
            CreateBy = "CreateBy"
        }
    }
}
